<template>
  <div>
    <common-dialog ref="dialog" width="1050px" title="加工单列表" id-key="UserId" @close-saved="$emit('close-saved')" @closed="onClosed">
      <list ref="list" :temp-params="{Statuses :[3,4] ,ProductionType: 0, Stage: Stage, OrderType}" disabled :tableType="1" :processList="processList"></list>
      <div slot="footer">
        <el-button type="primary" @click="saved">保存</el-button>
      </div>
    </common-dialog>
  </div>
</template>  
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "./list";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    DictionaryId: {
      type: Number,
      default: 0,
    },
    Stage: {
      type: Number,
      default: 0,
    },
    OrderType: {
      type: Number,
      default: 0,
    },
    processList: {
      type: Array,
      default: () => [],
    }

  },
  methods: {
    get_data(o) {
      this.$nextTick(() => {
        console.log('o', o)
        this.$refs.list.$refs.list.query(o)
      })
    },
    saved() {
      let list = this.$refs.list.list;
      let subList = this.$refs.list.subList;
      let extraList = this.$refs.list.extraList;
      console.log("list", list, "sublist", subList, "extralist", extraList);
      this.$emit('saved', { list, subList, extraList });
      this.close();
    },
    onClosed() {
      this.$refs.list.onClear();
    }
  }
};
</script>
